import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { ActionState, BaseComponentConfig, ComponentConfig, getColumnFieldTitles, getFields, MenuTitleOptions, UbsComponentStoreService, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { FACILITY_OVERVIEW_FORMS } from '../forms';

@Component({
  selector: 'ubs-overview-roles',
  templateUrl: './overview-roles.component.html',
  styleUrls: ['./overview-roles.component.scss']
})
export class OverviewRolesComponent extends BaseComponentConfig implements OnInit{
  @Input() facilityId:string;

   options:ComponentConfig = {
     name: '',
     title: '',
     standAlone: true,
     defaultParameters: [],
     defaultAction: ActionState.LIST,
     idFieldName: '',
     findForm: new OfbizForm,
     addForm: new OfbizForm,
     addForms: [],
     listForms: [],
     listForm: new OfbizList({
       listFormName: 'EditFacilityParties',
       listFormLocation: 'component://kwikstore/widget/FacilityForms.xml',
       listType: 'grid',
       columnFieldTitles: getColumnFieldTitles('EditFacilityParties', FACILITY_OVERVIEW_FORMS),
       columnFields: getFields('EditFacilityParties', FACILITY_OVERVIEW_FORMS),
       findParameters: [],
       remoteFormData: {
         formData: {
           formName: 'EditFacilityParties',
           formLocation: 'component://kwikstore/widget/FacilityForms.xml',
           listType: 'grid',
           entityName: '',
           viewIndex: 0,
           viewSize: 0
         }
       },
       emptyListMessage: 'No data available'
     }),
     actions: [],
     settings: [],
     summaryView: [],
     lookUpEndPoint: '',
     searchResults: undefined,
     breadCrumbData: undefined,
     childComponent: new ComponentConfig,
     customContainerItems: [],
     lookups: [],
     relations: [],
     selectedRelation: undefined,
     masterDetails: [],
     selectedMasterDetails: undefined,
     appContext: '',
     outGoingLinks: [],
     tasks: [],
     menuAndTitleOptions: undefined,
     getMenuAndTitleOptions: function (): MenuTitleOptions {
       throw new Error('Function not implemented.');
     },
     selectedTask: undefined
   }

   componentConfig:ComponentConfig;
   
     constructor(viewContainerService:ViewContainersService,
       menuService:NbMenuService,
       route:ActivatedRoute,
       router:Router,
       updateComponentStoreService:UpdateComponentStoreService,
       configurationService:ConfigurationService,
       private componentStore:UbsComponentStoreService) { 
       super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
       }
   
     ngOnInit(): void {
       this.options.listForm.findParameters.push({"facilityId":this.facilityId})
       this.componentConfig = new ComponentConfig(this.options);
       this.componentStore.updateComponentConfig(this.componentConfig);
       console.log(this.componentConfig);
       this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
     }

}
